import type { TimelineTrack } from '@/types/timeline'
import { DEFAULT_TRACK_HEIGHT, MAX_TRACK_HEIGHT, MIN_TRACK_HEIGHT } from '../constants'
import { getTrackKind } from './classic-tracks'

export function clampTrackHeight(height: number): number {
  return Math.max(MIN_TRACK_HEIGHT, Math.min(MAX_TRACK_HEIGHT, Math.round(height)))
}

export function resizeTrackInList(
  tracks: TimelineTrack[],
  trackId: string,
  nextHeight: number,
): TimelineTrack[] {
  const clampedHeight = clampTrackHeight(nextHeight)
  let didChange = false

  const nextTracks = tracks.map((track) => {
    if (track.id !== trackId || track.height === clampedHeight) {
      return track
    }

    didChange = true
    return {
      ...track,
      height: clampedHeight,
    }
  })

  return didChange ? nextTracks : tracks
}

export function resizeAllTracksInList(
  tracks: TimelineTrack[],
  nextHeight: number,
): TimelineTrack[] {
  const clampedHeight = clampTrackHeight(nextHeight)
  let didChange = false

  const nextTracks = tracks.map((track) => {
    if (track.height === clampedHeight) {
      return track
    }

    didChange = true
    return {
      ...track,
      height: clampedHeight,
    }
  })

  return didChange ? nextTracks : tracks
}

export function resizeTracksOfKindByDelta(
  tracks: TimelineTrack[],
  kind: 'video' | 'audio',
  delta: number,
): TimelineTrack[] {
  let didChange = false

  const nextTracks = tracks.map((track) => {
    if (getTrackKind(track) !== kind) return track
    const nextHeight = clampTrackHeight(track.height + delta)
    if (nextHeight === track.height) return track
    didChange = true
    return { ...track, height: nextHeight }
  })

  return didChange ? nextTracks : tracks
}

export function resetAllTrackHeights(tracks: TimelineTrack[]): TimelineTrack[] {
  return resizeAllTracksInList(tracks, DEFAULT_TRACK_HEIGHT)
}
